import { Space, Typography } from "antd";
import { MailOutlined } from "@ant-design/icons";
import React from "react";

export const EventMessage = (props: {
  message?: string;
  color: string;
  t: any;
}) => {
  let component =
    props.message !== undefined ? (
      <div
        style={{
          display: "inline-block",
          maxWidth: "100%",
          padding: "8px 12px",
          backgroundColor: "#fffbe6",
          borderLeft: "3px solid #faad14",
          borderRadius: 4,
          boxShadow: "0 2px 8px rgba(95, 75, 16, 0.12)",
          color: "#5f4b10",
          margin: "8px 0",
        }}
      >
        <Space>
          <MailOutlined />
          <strong>{props.t("Note")}:</strong>
        </Space>
        <Typography.Paragraph
          style={{
            display: "inline-block",
            marginLeft: 5,
            marginBottom: 0,
            color: "inherit",
          }}
          ellipsis={{
            rows: 2,
            expandable: true,
            symbol: "more",
          }}
        >
          {props.message}
        </Typography.Paragraph>
      </div>
    ) : (
      <></>
    );
  return <>{component}</>;
};
